<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card/-header-default card-header-icon">
        <div class="card-icon">
          <i class="material-icons">cloud_sync</i>
        </div>
        <h4 class="card-title">Background Processes</h4>
      </div>
      <div class="card-body">

        <div class="toolbar">

          <br><br>

          <div class="row">
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Type</mat-label>
                <mat-select name="type" [(ngModel)]="filtertype" (selectionChange)="getList()">
                  <mat-option value="All">All</mat-option>
                  <mat-option value="SYNCPOFROMIQ">SYNCPOFROMIQ</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-2">

              <button class="btn btn-info" (click)="getList()">Refresh</button>

            </div>
          </div>
        </div>

       <!-- <div *ngIf="loading" style="text-align: center">
          <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
        </div>-->

         <ngx-skeleton-loader *ngIf="loading" count="10" appearance="line" animation="pulse"></ngx-skeleton-loader>

        <dinamic-table
          *ngIf="!loading"
          [id]="'saleordersTable'"
          [data]="purchasp"
          [campoBusqueda]="campoBusqueda"
          [perPage]="itemsPorPagina"
          [page]="paginaActual"
          [total_items_count]="totalItems"
          [total_pages]="totalPaginas"
          (action_button)="actions($event)"
          [search]="false"
          (buscar)="getList($event)"
        ></dinamic-table>

      </div>
    </div>
  </div>
</div>